module.exports = __webpack_public_path__ + "img/MongoDB.51e9ef2.svg";